import { GeneratedSingleThemeType } from "@/features/review-view/types";
import { SocialPostType } from "@/features/previous-post-view/types";
import { SocialPostType as SocialThemeType } from "@/features/review-view/types";

export const getPlatformPostsNew = (platform: string, posts: SocialThemeType[]): SocialThemeType[] => {
  const foundPosts: SocialThemeType[] = []
  posts.forEach(element => {
    if (element.platform.includes(platform)) {
      foundPosts.push(element)
    }
  });
  console.log("foundposts: ", foundPosts)
  return foundPosts
}


// Filtered posts when platform is selected
export const getPlatformPosts = (platform: string, posts: SocialPostType["content"]): SocialPostType["content"] => {
  const foundPosts: SocialPostType["content"] = []
  posts.forEach(element => {
    if (element.platform.includes(platform)) {
      foundPosts.push(element)
    }
  });
  return foundPosts
}

export type PostsArrangedByPlatform = {
  platform: string,
  content: SocialPostType["content"]
}[]

export const getAllPosts = (posts: SocialPostType["content"]): PostsArrangedByPlatform => {

  const data: PostsArrangedByPlatform = []

  const platforms: string[] = [];

  posts.forEach(element => {
    const found = platforms.findIndex(item => item === element.platform);
    if (found === -1) {
      platforms.push(element.platform)
      data.push({
        platform: element.platform,
        content: [element]
      })
    } else {
      const findPlatformData = data.findIndex(item => item.platform === element.platform)
      data[findPlatformData].content.push(element)
    }
  })

  return data
}

type Platform = {
  id: number;
  name: string;
  url: string;
};

type Post = {
  platform: string;
  // other fields omitted for brevity
};

// Helper to normalize platform names from post content to match your static list
function normalizePlatformName(name: string): string {
  if (name === "Twitter (X)") return "X";
  // if (name === "LinkedIn") return "Linkedin";
  return name;
}

export function filterPlatformsByPosts(posts: Post[], allPlatforms: Platform[]): Platform[] {
  const usedPlatformNames = new Set(
    posts.map(post => normalizePlatformName(post.platform))
  );

  return allPlatforms.filter(platform =>
    usedPlatformNames.has(normalizePlatformName(platform.name))
  );
}


export const getPlatformPostsForTheme = (platform: string, posts: GeneratedSingleThemeType[]): GeneratedSingleThemeType[] => {
  const foundPosts: GeneratedSingleThemeType[] = []
  posts.forEach(element => {
    if (element.platform.includes(platform)) {
      foundPosts.push(element)
    }
  });
  console.log("foundposts: ", foundPosts)
  return foundPosts
}
